import { render, staticRenderFns } from "./bullet-point.vue?vue&type=template&id=89ddde26&scoped=true&"
import script from "./bullet-point.vue?vue&type=script&lang=js&"
export * from "./bullet-point.vue?vue&type=script&lang=js&"
import style0 from "./bullet-point.vue?vue&type=style&index=0&id=89ddde26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ddde26",
  null
  
)

export default component.exports